/**
 * Resolved API base URL. Single source of truth so client.ts, authStore.ts, and the
 * SSE helpers agree.
 *
 * Cookie-auth model (Wave 2.4 fix): the browser must hit the builder's OWN origin so
 * the `__Host-` session cookie stays first-party. The apps/builder/api proxy relays
 * `/api/*` to the gateway and re-issues those cookies same-origin.
 *
 * Resolution order:
 *  1. An explicit RELATIVE value (e.g. "/api") is used verbatim.
 *  2. Any DEPLOYED bundle (`import.meta.env.PROD` — true for every `vite build`, i.e.
 *     both Vercel Production and Preview) ALWAYS uses the "/api" proxy. We deliberately
 *     ignore an absolute `VITE_API_URL` here: baking the cross-site gateway URL into a
 *     deployed bundle is exactly what broke the session. Forcing it in code makes the
 *     cutover atomic with the proxy and removes any per-environment env coordination.
 *  3. In dev only, an absolute `VITE_API_URL` is still honored so you can point a local
 *     `npm run dev` straight at a remote gateway; empty falls back to "/api".
 */
const _raw = (import.meta.env.VITE_API_URL as string)?.trim() ?? '';
export const API_URL = _raw.startsWith('/')
  ? _raw
  : import.meta.env.PROD
    ? '/api'
    : _raw
      ? _raw.startsWith('http')
        ? _raw
        : `https://${_raw}`
      : '/api';
